import { get } from 'lodash';
import React, { useContext } from 'react';
import { Chip } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const ChipRenderer = ({ dataKey, rowData }) => {
  const { t, theme } = useContext(ConfigContext);
  const creatorType = get(rowData, dataKey);
  const color = creatorType === 'initiator' ? theme.colors.primary : theme.colors.grey4;
  const backgroundColor = creatorType === 'initiator' ? theme.colors.primaryLight : theme.colors.disabled;

  return <Chip label={t(`swap-${creatorType}`)} color={color} background={backgroundColor} />;
};

export default ChipRenderer;
